import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import armTheme from "../styles/armTheme";

const Container = styled("div")(({ theme }) => ({
  display: "block",
  width: "100%",
  minWidth: 0,
  padding: theme.spacing(1.25, 1.75),
  overflow: "hidden",
}));

const VerticalBar = styled("span")(({ theme }) => ({
  color: armTheme.colours.primary.main,
  margin: theme.spacing(0, 0.5),
  fontWeight: 400,
}));

const Make = styled("span")({
  color: armTheme.colours.primary.main,
  fontSize: "0.9em",
  fontWeight: 600,
});

const Middot = styled("span")(({ theme }) => ({
  color: theme.palette.text.disabled,
  margin: theme.spacing(0, 0.6),
}));

const banSx = { color: "#c97a00", fontWeight: 500 };

function getBans(result) {
  const bans = [];
  if (result.banned_oic1?.raw === "Yes") bans.push("OIC #1");
  if (result.banned_oic2?.raw === "Yes") bans.push("OIC #2");
  if (result.banned_oic3?.raw === "Yes") bans.push("OIC #3");
  if (result.banned?.raw === "Yes (Live FRT Only)") bans.push("Prohibited in Live FRT");
  return bans;
}

export default function AccordionSummaryContent({ result }) {
  const bans = getBans(result);
  const calibres = result.calibres?.raw;

  return (
    <Container>
      <Typography
        variant="subtitle1"
        component="h2"
        sx={{ fontWeight: 600, lineHeight: 1.3, color: "text.primary" }}
      >
        {result.model.raw}<VerticalBar>|</VerticalBar><Make>{result.make.raw}</Make>
      </Typography>
      <Typography
        variant="body2"
        component="div"
        color="text.secondary"
        sx={{ mt: 0.25 }}
      >
        {result.type.raw}<Middot>·</Middot>{result.action.raw}<Middot>·</Middot>{result.legal_classification.raw}
        {bans.map((b, i) => (
          <React.Fragment key={i}>
            <Middot>·</Middot>
            <Box component="span" sx={banSx}>{b}</Box>
          </React.Fragment>
        ))}
      </Typography>
      <Typography
        variant="caption"
        component="div"
        color="text.secondary"
        noWrap
        sx={{ mt: 0.5 }}
      >
        Calibres: {calibres?.length > 0 ? calibres.join(", ") : "—"}
      </Typography>
    </Container>
  );
}

AccordionSummaryContent.propTypes = {
  result: PropTypes.object,
};
